<template>
  <b-form @submit.prevent>
    <b-row>
      <b-col cols="12">
        <b-form-group
          label="Slug:"
          label-for="slug"
        >
          <ValidationProvider
            #default="{ errors }"
            name="slug"
            vid="slug"
          >
            <b-form-input
              id="slug"
              v-model="clinicNetworksData.slug"
              autocomplete="off"
              placeholder="slug"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          label="Название:"
          label-for="name"
        >
          <ValidationProvider
            #default="{ errors }"
            name="name"
            vid="name"
          >
            <b-form-input
              id="name"
              v-model="clinicNetworksData.name"
              autocomplete="off"
              placeholder="Название"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="d-flex flex-row-reverse">
      <div>
        <b-button
          variant="primary"
          class="float-right"
          @click="formSubmit"
        >
          {{ clinicNetworksData.id ? 'Обновить и закрыть' : 'Создать и закрыть' }}
        </b-button>
      </div>
      <div>
        <b-button
          variant="flat-danger"
          class="mr-1"
          @click="$router.back()"
        >
          Отменить
        </b-button>
      </div>
    </div>
  </b-form>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BForm,
  BFormGroup,
  BButton,
} from 'bootstrap-vue'

export default {
  name: 'ClinicNetworksForm',
  components: {
    BButton,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
  },
  props: {
    clinicNetworksData: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    formSubmit() {
      this.$emit('formSubmit', true)
    },
  },
}
</script>
